import Basic from './basic.vue';
import MobBasic from './mob_basic.vue';

export const componentMap = {
	basic: Basic,
	'mob-basic': MobBasic
};
